const style = {
  borderStyle: {
    width: '2vmin',
    height: '2vmin',
    borderRadius: '2vmin',
    border: 'solid 0.0vmin rgba(255, 255, 255, 0.0)',
  },
  borderStyleSelected: {
    width: '5vmin',
    height: '5vmin',
    borderRadius: '5vmin',
    border: 'solid 0.65vmin rgba(255, 255, 255, 1.0)',
  },
  iconStyle: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '2vmin',
    height: '2vmin',
    backgroundColor: '#17E685',
    WebkitTransform: 'translate(-50%, -50%) rotate(0deg)',
    MozTransform: 'translate(-50%, -50%) rotate(0deg)',
    OTransform: 'translate(-50%, -50%) rotate(0deg)',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    borderRadius: '2vmin',
  },
  iconStyleHighlighted: {
    width: '3vmin',
    height: '3vmin',
    backgroundColor: '#B6F2D6',
  },
  mainIconStyle: {
    width: '3vmin',
    height: '3vmin',
  },
  iconStyleSelected: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '3vmin',
    height: '3vmin',
    backgroundColor: '#B6F2D6',
    WebkitTransform: 'translate(-50%, -50%) rotate(0deg)',
    MozTransform: 'translate(-50%, -50%) rotate(0deg)',
    OTransform: 'translate(-50%, -50%) rotate(0deg)',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    borderRadius: '3vmin',
  },
  iconStyleGrabbed: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '3vmin',
    height: '3vmin',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    WebkitTransform: 'translate(-50%, -50%) rotate(0deg)',
    MozTransform: 'translate(-50%, -50%) rotate(0deg)',
    OTransform: 'translate(-50%, -50%) rotate(0deg)',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    borderRadius: '3vmin',
  },
  spanStyle: {
    transformOrigin: '0 0',
    position: 'absolute',
    left: '50%',
    top: '50%',
    fontSize: '2vmin',
    WebkitTransform: 'translate(-50%, -50%) rotate(0deg)',
    MozTransform: 'translate(-50%, -50%) rotate(0deg)',
    OTransform: 'translate(-50%, -50%) rotate(0deg)',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    color: '#084D2C',
    pointerEvents: 'none',
  },

  spanStyleGrabbed: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    fontSize: '3vmin',
    WebkitTransform: 'translate(-50%, -50%) rotate(0deg)',
    MozTransform: 'translate(-50%, -50%) rotate(0deg)',
    OTransform: 'translate(-50%, -50%) rotate(0deg)',
    transform: 'translate(-50%, -50%) rotate(0deg)',
    color: '#B6F2D6',
    pointerEvents: 'none',
  },

  widgetStyle: (positionX, positionY) => ({
    position: 'absolute',
    left: `${positionX * 100}%`,
    top: `${positionY * 100}%`,
    width: '5vmin',
    height: '5vmin',
    borderRadius: '5vmin',
    WebkitTransform: 'translate(-50%, -50%)',
    MozTransform: 'translate(-50%, -50%)',
    OTransform: 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    // backgroundColor: '#17E685',
    filter: 'drop-shadow(0 0 20px rgba(0, 0, 0, 0.75))',
    outline: 'none',
  }),

  spreadIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: '#B6F2D6',
    fontSize: '9vmin',
    transform: 'translate(-50%, -50%)',
    zIndex: -1,
  },

  iconWrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  connectorPointStyle: (positionX, positionY) => ({
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    backgroundColor: 'rgb(23, 230, 133)',
    position: 'absolute',
    top: `${positionX}px`,
    left: `${positionY}px`,
    transform: 'translate(-50%, -50%)',
  }),
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Map/MapWidget/MapWidget.styles.js